const email = [
  {
    required: true,
    message: "Please enter Email",
  },
];
const password = [
  {
    required: true,
    message: "Please input your password",
  },
  // {
  //   pattern: new RegExp(
  //     /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w~@#$%^&*+=`|{}:;!.?\"()\[\]-]{8,25}$/
  //   ),
  //   message:
  //     "Please enter atleast 8 characters password with one Number, one UpperCase and atleast one lowercase character!",
  // },
];

const newPassword = [
  {
    required: true,
    message: "Please input your password",
  },
  {
    pattern: new RegExp("^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).*$"),
    message:
      "Password should have at least one Numeric, one Uppercase letter, one special character",
  },
  {
    min: 8,
    message: "The length should be of minimum 8 characters",
  },
  {
    max: 20,
    message: "Text length exceeds the maximum limit of 20 characters",
  },
];

const confirmPassword = [
  {
    required: true,
    message: "Password does not match",
  },
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue("password") === value) {
        return Promise.resolve();
      }
      return Promise.reject("Passwords do not match");
    },
  }),
];

const username = [
  {
    required: true,
    message: "Please enter username",
  },
  {
    min: 3,
    message: "The length should be of minimum 3 characters",
  },
  {
    max: 25,
    message: "Text length exceeds the maximum limit of 25 characters",
  },
  {
    whitespace: true,
    message: "Username must not be blank",
  },
  {
    pattern: /^[A-Za-z]+$/,
    message: "Only alphabets (A-Z, a-z) are allowed in this field.",
  },
];

const requiredField = [{ required: true, message: "This field is required" }];

export default {
  email,
  password,
  newPassword,
  confirmPassword,
  username,
  requiredField,
};
